import { render, staticRenderFns } from "./CourseFormModal.vue?vue&type=template&id=2d479929&scoped=true"
import script from "./CourseFormModal.vue?vue&type=script&lang=js"
export * from "./CourseFormModal.vue?vue&type=script&lang=js"
import style0 from "./CourseFormModal.vue?vue&type=style&index=0&id=2d479929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d479929",
  null
  
)

export default component.exports